import { BoxProps } from '@chakra-ui/react';
import React from 'react';
import { MBox, MDivider, MText } from '../../../components/Monetize';

interface SettingsSectionProps extends BoxProps {
  label?: string;
  children: React.ReactNode;
  showDivider?: boolean;
}

export const SettingsSection = ({
  label,
  children,
  showDivider = true,
  ...boxProps
}: SettingsSectionProps) => {
  return (
    <MBox w="100%" p={1} {...boxProps}>
      {label && (
        <MText fontSize="md" fontWeight="600" mb="4">
          {label}
        </MText>
      )}
      {children}
      {showDivider && <MDivider my="4" />}
    </MBox>
  );
};
